import React from "react";
import {ACol, AContainer, APanel, ARow} from "@cisco-sbg-ui/magna-react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {IncidentDrawer} from "features/drawers";
import IncidentsDateRange from "features/incidents/IncidentsDateRange/IncidentsDateRange";
import MetricsCards from "features/incidents/MetricsCards/MetricsCards";
import {IncidentsContext, IncidentsProvider} from "contexts/IncidentsContext";
import useDrawer from "hooks/useDrawer";
import TableFilter from "../components/Table/TableFilter";
import IncidentsLandingPageContent from "../features/incidents/IncidentsLandingPageContent/IncidentsLandingPageContent";
import IncidentsTable from "../features/incidents/IncidentsTable/IncidentsTable";
import {
  selectIncidentLoading,
  selectIncidentsLoading,
  selectIncidentTotalRows,
  selectTotalIncidentsCount
} from "../store/selectors";

const Incidents = () => {
  const {t} = useTranslation();
  const {isOpen, open: openDrawer, close: closeDrawer} = useDrawer();

  const results = useSelector(selectIncidentTotalRows);
  const isLoading = useSelector(selectIncidentsLoading);
  const totalIncidentsCount = useSelector(selectTotalIncidentsCount);

  return (
    <div className="incidents-page">
      <IncidentsProvider>
        <AContainer fluid data-testid={"Incidents-Container"}>
          <ARow className="align-center">
            <ACol>
              <h1 className="app-title">{t("app.title")}</h1>
            </ACol>
            <ACol className="d-flex justify-end">
              <IncidentsDateRange />
            </ACol>
          </ARow>
          <MetricsCards />
          <APanel
            className="pa-4 overflow-visible"
            style={{marginLeft: 2, marginRight: 2}}>
            {!isLoading && totalIncidentsCount === 0 ? (
              <IncidentsLandingPageContent />
            ) : (
              <>
                <TableFilter
                  name="incidents"
                  loadingSelector={selectIncidentLoading}
                  totalDisplay={
                    <div className="ml-2 align-self-center text-no-wrap">
                      {t("incidents.filters.totalRows", {count: results})}
                    </div>
                  }
                  context={IncidentsContext}
                  className="mb-4"
                  filterChips
                  dropdown
                />
                <IncidentsTable openDrawer={openDrawer} />
              </>
            )}
          </APanel>
          <IncidentDrawer isOpen={isOpen} onClose={closeDrawer} />
        </AContainer>
      </IncidentsProvider>
    </div>
  );
};

export default Incidents;
